/**
 * Built-in tool configurations
 * These are tools that are handled by the backend and rendered via ToolCallRenderer
 */
export const BUILTIN_TOOLS = {
  // Staged-action tools
  CREATE_STAGED_ACTION: 'create_staged_action',
  EDIT_STAGED_ACTION: 'edit_staged_action',
  QUERY_STAGED_ACTIONS: 'query_staged_actions',
  SEARCH_STAGED_ACTIONS: 'search_staged_actions',
  CREATE_REMINDER: 'reminders_create_item',

  // Backend tools
  GENERATE_IMAGE: 'generate_image',
  EXA_SEARCH: 'exa_search',
  SEARCH_AUDIO_NOTES: 'search_audio_notes',
  SEARCH_KNOWLEDGE: 'search_knowledge',
  SEARCH_HIGHLIGHTS: 'search_highlights',
  MANAGE_CUSTOM_INSTRUCTIONS: 'manage_custom_instructions',
  MANAGE_SKILL: 'manage_skill',

  // Interactive tools (round-trip back to the user, like MCP tools)
  ASK_USER_QUESTION: 'AskUserQuestion',
  ASK_USER_FEEDBACK: 'AskUserFeedback',
} as const

/**
 * Tool display names for UI
 */
export const TOOL_DISPLAY_NAMES: Record<string, string> = {
  [BUILTIN_TOOLS.EDIT_STAGED_ACTION]: 'Editing action',
  [BUILTIN_TOOLS.QUERY_STAGED_ACTIONS]: 'Querying actions',
  [BUILTIN_TOOLS.SEARCH_STAGED_ACTIONS]: 'Searching actions',
  [BUILTIN_TOOLS.CREATE_REMINDER]: 'Creating reminder item',
  [BUILTIN_TOOLS.GENERATE_IMAGE]: 'Generating image',
  [BUILTIN_TOOLS.EXA_SEARCH]: 'Searching the web',
  [BUILTIN_TOOLS.SEARCH_AUDIO_NOTES]: 'Searching audio notes',
  [BUILTIN_TOOLS.SEARCH_KNOWLEDGE]: 'Searching knowledge base',
  [BUILTIN_TOOLS.SEARCH_HIGHLIGHTS]: 'Searching highlights',
  [BUILTIN_TOOLS.MANAGE_CUSTOM_INSTRUCTIONS]: 'Updating custom instructions',
  [BUILTIN_TOOLS.MANAGE_SKILL]: 'Managing skill',
  [BUILTIN_TOOLS.ASK_USER_QUESTION]: 'Asking a question',
  [BUILTIN_TOOLS.ASK_USER_FEEDBACK]: 'Asking for feedback',
  request_auto_mode: 'Writing a plan',
  approve_staged_action: 'Approving action',
}

const BUILTIN_TOOL_NAMES = new Set<string>(Object.values(BUILTIN_TOOLS))

/**
 * Check if a tool is a built-in tool
 */
export function isBuiltinTool(toolName: string): boolean {
  return BUILTIN_TOOL_NAMES.has(toolName)
}

/**
 * Get display name for a tool
 */
export function getToolDisplayName(toolName: string): string {
  return TOOL_DISPLAY_NAMES[toolName] || toolName
}
